import Repository from './Repository';

const resource = 'api/sysInfo';

export default {
  get(): Promise<any> {
    return Repository.get(resource);
  },
};
